/**
 * Filtro responsável por gerar o nome curto de uma pessoa. O nome curto será composto pelo
 * primeiro e o último nomes.
 */
angular.module("avlib").filter('avShortName', function () {
    return function(name){
    	if (name != null){
    		var trimmedName = name.trim();
    		var lastSpaceIndex = trimmedName.lastIndexOf(" ");
    		if (lastSpaceIndex > -1){
    			var lastName = trimmedName.substring(lastSpaceIndex); 
    			var firstName = trimmedName.substring(0, trimmedName.indexOf(" ")+1);
    			return firstName+lastName;
    		}
    		return name;
    	}
    	return null;
    };
});
